import { uniq } from "lodash";
import { useMemo } from "react";
import { isFullCustodian, isLimitedCustodian, } from "../../Types";
import useClientDashboard from "./useClientDashboard";
export default function useClientCustodian(clientId, authConfig, preFetch = false) {
    const dashboard = useClientDashboard(clientId, authConfig, preFetch);
    const result = useMemo(() => {
        if (preFetch) {
            return {
                data: undefined,
                isLoading: true,
                hasError: false,
                preFetch: dashboard.preFetch,
            };
        }
        if (dashboard.isLoading || dashboard.hasError) {
            return dashboard;
        }
        const allCustodians = dashboard.data.accountDetails.map((d) => d.accountDetails.custodian);
        const uniqueCustodians = uniq(allCustodians);
        if (uniqueCustodians.length === 0) {
            const data = isFullCustodian(dashboard.data.defaultCustodian)
                ? {
                    type: "SingleFullCustodian",
                    custodian: dashboard.data.defaultCustodian,
                    limitedCustodians: [],
                }
                : {
                    type: "Limited",
                    limitedCustodians: [dashboard.data.defaultCustodian],
                };
            return {
                data,
                isLoading: false,
                hasError: false,
                preFetch: dashboard.preFetch,
            };
        }
        const fullCustodians = uniqueCustodians.filter(isFullCustodian);
        const limitedCustodians = uniqueCustodians.filter(isLimitedCustodian);
        if (fullCustodians.length === 1 && fullCustodians[0] !== undefined) {
            return {
                data: {
                    type: "SingleFullCustodian",
                    custodian: fullCustodians[0],
                    limitedCustodians,
                },
                isLoading: false,
                hasError: false,
                preFetch: dashboard.preFetch,
            };
        }
        const data = fullCustodians.length === 0
            ? { type: "Limited", limitedCustodians }
            : {
                type: "MultipleFullCustodians",
                custodians: fullCustodians,
                limitedCustodians,
            };
        return {
            data,
            isLoading: false,
            hasError: false,
            preFetch: dashboard.preFetch,
        };
    }, [dashboard, preFetch]);
    return result;
}
//# sourceMappingURL=useClientCustodian.js.map